import React from 'react';
import styled from 'styled-components';
import { Margin, p, mb, mt, pl } from '@nib/layout';
import { AddFunnelPropFromContext } from '../funnel-context';
import { ConfirmationCheckbox, FUNNELS } from '../..';
import { Field } from 'formik';
import { formHelpTextSize, copyColor, colorDarker, linkLoud, copyFontFamily, formLabelColor, formLabelSize } from '@nib-components/theme';
import Copy from '@nib-components/copy';
import { LinkList, LinkListItem } from '../link-list';
import { defaultFieldPropTypes } from '../../types';
export const DisclaimerCopy = styled.div`
  font-size: ${formHelpTextSize};
  color: ${copyColor};
`;
export const GroupFieldLabel = styled.div`
  display: block;
  color: ${formLabelColor};
  font-family: ${copyFontFamily};
  font-size: ${formLabelSize};
  font-weight: 700;
  line-height: 1.5;
`;
const DeclarationGroupContainer = styled.div`
  border: 1px solid ${colorDarker};
  ${p(4)};
`;
const Ul = styled.ul`
  margin: 0;
  ${mt(5)};
  padding: 0;
  ${pl(4)};
  font-size: 1rem;
  color: ${copyColor};
`;
const Li = styled.li`
  ${mb(4)};
  ${pl(2)};
  a {
    color: ${linkLoud};
  }
`;
export const DeclarationGroup = props => {
  const {
    funnel = FUNNELS.ARHI,
    label = '',
    help = '',
    width = 20,
    optional = false,
    values,
    description,
    declarationList,
    declarationLabel,
    declarations,
    links,
    ...otherProps
  } = props;
  return React.createElement("div", null, React.createElement(Margin, {
    bottom: 4
  }, React.createElement(GroupFieldLabel, null, declarationLabel)), React.createElement(DeclarationGroupContainer, null, React.createElement(Copy, {
    measure: false
  }, description), React.createElement(Ul, null, declarationList.map((item, index) => {
    return React.createElement(Li, {
      key: index,
      dangerouslySetInnerHTML: {
        __html: item
      }
    });
  })), declarations.map((item, index) => {
    return React.createElement(Field, {
      key: index,
      name: item.name,
      id: item.name,
      component: ConfirmationCheckbox,
      checked: values ? values[item.name] : false,
      label: item.label,
      ...otherProps
    });
  }), links && React.createElement(LinkList, null, links.map(item => React.createElement(LinkListItem, {
    item: item,
    key: item.text
  })))));
};
DeclarationGroup.defaultProps = {
  ...defaultFieldPropTypes
};
const DeclarationGroupWithFunnel = props => React.createElement(AddFunnelPropFromContext, null, React.createElement(DeclarationGroup, {
  ...props
}));
export default DeclarationGroupWithFunnel;